export default [
	{
		dataIndex: 'created_at',
		key: 'datetime',
		title: 'Date Time',
		align: 'center',
		scopedSlots: {customRender: 'datetime'},
		width: 145
	}, {
		key: 'bank',
		title: 'Bank',
		scopedSlots: {customRender: 'bank'}
	}, {
		key: 'account',
		title: 'Account',
		scopedSlots: {customRender: 'account'}
	}, {
		key: 'balance',
		title: 'Balance',
		align: 'center',
		scopedSlots: {customRender: 'balance'}
	}, {
		key: 'action',
		title: '',
		align: 'right',
		width: 150,
		scopedSlots: {customRender: 'action'}
	}
]
